<template>
  <div class="row align-items-start service">
    <div class="col-6 col-md-5">
      <h4>{{ title }}</h4>
      <p v-if="description" v-html="description" ></p>
    </div>
    <div class="col-2 col-md-3">
      <!-- <h4  v-if="uid== 13">{{ toPrice(price * reservation.nights) }}  </h4>
      <h4  v-else>{{ toPrice(price) }} </h4> -->
      <h4 >{{ toPrice(price) }} </h4> 
      <!-- <h4  v-if="is_per_day==true">{{ toPrice(price * reservation.nights) }} - {{reservation.nights}} x {{price}} </h4>
      <h4  v-else>{{ toPrice(price) }} </h4> -->
    </div>
    <div class="col-2">
      <select class="form-select" v-model="selected" @change="addAdditional">
        <option>0</option>
        <option>1</option>
        <option>2</option>
        <option>3</option> 
        <option>4</option>
        <option>5</option>
        <option>6</option> 
        <option>7</option>
        <option>8</option>
        <option>9</option>
      </select>
    </div>
    <div class="col-2 text-right text-end">
      <!-- <h5 v-if="uid== 13">{{ toPrice(price * reservation.nights * selected) }}</h5>
      <h5 v-else>{{ toPrice(price * selected) }}</h5> -->

      <h4>{{ toPrice(price * selected) }}</h4>

       <!-- <h4 v-if="is_per_day==true">{{ toPrice(price * reservation.nights * selected) }}</h4>
      <h4 v-else>{{ toPrice(price * selected) }}</h4> -->

    </div>
    <div class="col-12 d-none d-md-block">
      <hr>
    </div>
  </div>
</template>

<script >
export default {
  name: "AdditionalListItem",
  inject: ["reservation"],
  props: { uid: Number, is_per_day: Boolean, title: String, description: String, price: Number },
  data() {
    return {
      selected: 0,
      sum: 0,
    };
  },
  methods: {
    addAdditional() {
      var params = {
        selected: this.selected,
        uid: this.uid,
        price: this.price,
        title: this.title,
      };
      this.$emit("update", params);
    },
  },
};
</script>